import { render, staticRenderFns } from "./OAuthRedirect.vue?vue&type=template&id=ea839f4a&"
import script from "./OAuthRedirect.vue?vue&type=script&lang=ts&"
export * from "./OAuthRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports